<template>
<div class="wrapper">
    <div class="configurator" style="width:500px; float:left">
            <p>Verschijningsvorm
              <select v-model="configdata.verschijningsvorm">
              <option>1 laag met kap</option>
              <option>2 lagen met kap</option>
              <option>2 lagen met plat dak</option>
              <option>3 lagen met plat dak</option>
              <option>2 en 3 lagen met plat dak gecombineerd</option>
              <option>1 laag met kap (levensloopbestendig)</option>
            </select></p>
            <p>Diepte
              <select v-model="configdata.diepte">
                <option v-if="configdata.display.diepte88">8,8 meter</option>
                <option v-if="configdata.display.diepte94">9,4 meter</option>
                <option v-if="configdata.display.diepte103">10,3 meter</option>
              </select>
            </p>
            <p>Architectuur
              <select v-model="configdata.architectuurkosten">
                <option>Ter waarde van € 2500</option>
                <option>Ter waarde van € 4000</option>
                <option>Ter waarde van € 5500</option>
              </select>
              <select v-model="configdata.architectuur">
                <option v-if="configdata.display.archeigentijds">Eigentijds</option>
                <option v-if="configdata.display.archj30 && configdata.architectuurkosten !== 'Ter waarde van € 2500'">Jaren 30</option>
                <option v-if="configdata.display.archlandelijk">Landelijk Romantisch</option>
                <option v-if="configdata.display.archmodern">Modern</option>
                <option v-if="configdata.display.archoudhollands">Oud Hollands</option>
              </select>
            </p>
            <p>Heipalen
              <select v-model="configdata.opties.heipalen">
                <option>Prefab 10 meter</option>
                <option>Prefab 15 meter</option>
                <option>Prefab 20 meter</option>
                <option>Mortel schroef 10 meter</option>
                <option>Mortel schroef 15 meter</option>
                <option>Mortel schroef 20 meter</option>
              </select>
            </p>
            <p>Start bouw
              <select v-model="configdata.opties.startjaar">
                <!-- <option>2021</option> -->
                <option>2022</option>
              </select>
            </p>
            <div>
              <h3>Totaal aantal woningen in dit blok: {{ $store.getters.numberOfHouses(id) }}</h3>
              <p v-if="configdata.display.beukmaat51"><label>Aantal beukmaat 5,1 meter</label><input type="number" min="0" max="30" v-model="configdata.aantallen.beukmaat51"></p>
              <p v-if="configdata.display.beukmaat54"><label>Aantal beukmaat 5,4 meter</label><input type="number" min="0" max="30" v-model="configdata.aantallen.beukmaat54"></p>
              <p v-if="configdata.display.beukmaat57">Aantal beukmaat 5,7 meter <input type="number" min="0" max="30" v-model="configdata.aantallen.beukmaat57"></p>
              <p v-if="configdata.display.beukmaat60">Aantal beukmaat 6,2 meter <input type="number" min="0" max="30" v-model="configdata.aantallen.beukmaat60"></p>
            </div>
            <div v-if="configdata.verschijningsvorm == '2 en 3 lagen met plat dak gecombineerd'">
              <h3>Kies verdeling</h3>
              <p>Aantal woningen met 2 lagen <input type="number" min="0" max="30" v-model="configdata.aantallen.tweelagen"></p>
              <p>Aantal woningen met 3 lagen <input type="number" min="0" max="30" v-model="configdata.aantallen.drielagen"></p>
              <p>Aantal overgangen van 2 naar 3 lagen <input type="number" min="0" max="30" v-model="configdata.aantallen.overgang"></p>
              <p>Type hoekwoning links
                <select v-model="configdata.typelinks">
                  <option>2 lagen</option>
                  <option>3 lagen</option>
                </select>
              </p>
              <p>Type hoekwoning rechts
                <select v-model="configdata.typerechts">
                  <option>2 lagen</option>
                  <option>3 lagen</option>
                </select>
              </p>
            </div>
            <div>
              <h3>Kies ontwerpopties</h3>
              <p v-if="configdata.display.aanbouw">Aantal woningen met aanbouw <input type="number" min="0" :max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.aanbouw"></p>
              <p v-if="configdata.display.dakkapel">Aantal woningen met dakkapel <input type="number" min="0" :max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.dakkapel"></p>
              <p v-if="configdata.display.tuitgevel">Aantal woningen met tuitgevel <input type="number" min="0" max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.tuitgevel"></p>
              <p v-if="configdata.display.slaapzolder">Aantal woningen met slaapkamer op zolder <input type="number" min="0" max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.slaapzolder"></p>
              <p v-if="configdata.display.slaapkamerllb">Aantal woningen met 1 extra slaapkamer<input type="number" min="0" max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.llb1slaapkamer"></p>
              <p v-if="configdata.display.slaapkamerllb">Aantal woningen met 2 extra slaapkamers<input type="number" min="0" max="$store.getters.numberOfHouses(id)" v-model="configdata.aantallen.llb2slaapkamer"></p>
            </div>
            <div>
            <h3>Kies woningafwerking</h3>
            <p>Sanitairpakket
              <select v-model="configdata.opties.sanitair">
                <option>Comfort</option>
                <option>Luxe</option>
                <option>Excellent</option>
              </select>
            </p>
            <p>Tweede toilet badkamer
              <select v-model="configdata.opties.tweedetoilet">
                <option>Nee</option>
                <option>Ja</option>
              </select>
            </p>
            <p>Douchewand
              <select v-model="configdata.opties.douchewand">
                <option>Geen</option>
                <option>Glazen douchewand</option>
                <option>Glazen douchewand + deur</option>
              </select>
            </p>
            <p>Bad
              <select v-model="configdata.opties.bad">
                <option>Nee</option>
                <option>Ja</option>
              </select>
            </p>
            <p>Keuken
              <select v-model="configdata.opties.keuken">
                <option>Geen</option>
                <option>Ter waarde van € 2000</option>
                <option>Ter waarde van € 4000</option>
                <option>Ter waarde van € 6000</option>
              </select>
            </p>
            <p>Wandafwerking
              <select v-model="configdata.opties.wandafwerking">
                <option>Behangklaar</option>
                <option>Sausklaar</option>
                <option>Scanbehang wit gesausd</option>
              </select>
            </p>
            <p v-if="configdata.display.wittedakplaten">Witte afwerking onderkant dakplaten
              <select v-model="configdata.opties.wittedakplaten">
                <option>Nee</option>
                <option>Ja</option>
              </select>
            </p>
            <p>Nul op de Meter
              <select v-model="configdata.opties.nom">
                <option>Nee</option>
                <option>Ja</option>
              </select>
            </p>
          </div>
            <!-- <h3>Planning</h3> -->
            

            <!-- <p>Totaalprijs: € {{ numberWithDots(price) }},-</p> -->
            <p>Totaalprijs: € {{ numberWithDots(this.$store.getters.priceOfBlock(this.id)) }}</p>
            <p>Gemiddeld per woning: € {{ numberWithDots(this.$store.getters.average(id)) }},-</p>
            <p>Totale lengte blok: {{ this.$store.getters.totalLength(id) }} meter</p>
            <p>Totale GBO: {{ numberWithDots(this.$store.getters.gbo(id)) }} m2</p>
            <p>GBO per woning: {{ this.$store.getters.numberOfHouses(id) ? Math.floor(this.$store.getters.gbo(id) / this.$store.getters.numberOfHouses(id)) : 0 }} m2</p>
            <p>Totale inhoud: {{ numberWithDots(this.$store.getters.bi(id)) }} m3</p>
            <!-- <img src="https://www.fijn.com/assets/img/logo.svg" style="width:100px; display: block; margin: auto"> -->
          </div>
          <div class="impression">
            <div class="architecture">
              <div class="impressie">
                <h3>Verschijningsvorm</h3>
                <img  class="crop" v-bind:src="'static/img/types/' + $store.getters.blockType(id) + '.jpg'">
                <!-- <p>Prototype</p> -->
              </div>
              <div class="impressie">
                <h3>Architectuur</h3>
                <img  class="crop" v-bind:src="'static/img/architectuur/' + $store.getters.blockById(id).architectuur + '.jpg'">
                <p>Prototype 3.0</p>
              </div>
              
            </div>
          <div class="plattegronden">
            <img style="width:900px" v-bind:src="'static/img/' + $store.getters.blockType(id) + '/30_' + $store.getters.blockType(id) + '_pg.png'">
            <p>Prototype 3.0</p>
            <!-- <img style="width:300px" v-bind:src="'static/img/' + $store.getters.blockType(id) + '/' + $store.getters.blockType(id) + 'pg0.jpg'">
            <img style="width:300px" v-bind:src="'static/img/' + $store.getters.blockType(id) + '/' + $store.getters.blockType(id) + 'pg1.jpg'">
            <img v-if="configdata.display.heefttweedeverdieping" style="width:300px" v-bind:src="'static/img/' + $store.getters.blockType(id) + '/' + $store.getters.blockType(id) + 'pg2.jpg'"> -->
          </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
import { blockMixin } from '../mixins/block'

export default {
  mixins: [blockMixin],
  props: ['id'],
  data: function() {
        return {
            configdata: {
                verschijningsvorm: '2 lagen met kap',
                diepte: '8,8 meter',
                architectuurkosten: 'Ter waarde van € 4000',
                architectuur: 'Jaren 30',
                typerechts: '2 lagen',
                typelinks: '2 lagen',
                opties : {
                    sanitair : 'Comfort',
                    tweedetoilet : 'Nee',
                    douchewand : 'Geen',
                    bad : 'Nee',
                    wandafwerking : 'Behangklaar',
                    wittedakplaten : 'Nee',
                    nom : 'Nee',
                    heipalen: 'Prefab 10 meter',
                    startjaar : '2022',
                    keuken: 'Geen'
                },
                // types: ["101", "200", "301", "302"],
                display: {
                    beukmaat51: 1,
                    beukmaat54: 1,
                    beukmaat57: 1,
                    beukmaat60: 0,
                    archj30: 1,
                    archeigentijds: 1,
                    archlandelijk: 1,
                    archmodern: 1,
                    archoudhollands: 1,
                    dakkapel: 1,
                    diepte88: 1,
                    diepte94: 1,
                    diepte103: 0,
                    aanbouw : 1,
                    tuitgevel: 1,
                    slaapzolder: 1,
                    wittedakplaten: 1,
                    heefttweedeverdieping: 1,
                    slaapkamerllb: 0,
                },
                aantallen : {
                    beukmaat51 : 0,
                    beukmaat54 : 0,
                    beukmaat57 : 0,
                    beukmaat60 : 0,
                    dakkapel : 0,
                    aanbouw : 0,
                    tuitgevel : 0,
                    slaapzolder : 0,
                    drielagen: 0,
                    tweelagen: 0,
                    overgang: 0,
                    llb1slaapkamer: 0,
                    llb2slaapkamer: 0,
                },
            },
        }
    },
    methods : {
      numberWithDots: function(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
    computed: {
        ...mapGetters([
          'fullConfig',
          'type'
        ]),
        ...mapMutations([
          'updateConfiguration'
        ]),
        type: function() {
          switch(this.configdata.verschijningsvorm) {
                case '1 laag met kap (levensloopbestendig)':
                    return '101llb'
                case '1 laag met kap':
                    return '101';
                case '2 lagen met kap':
                    switch(this.configdata.diepte) {
                        case '8,8 meter': return '201';
                        case '9,4 meter': return '301';
                    }
                case '2 lagen met plat dak':
                    switch(this.configdata.diepte) {
                        case '8,8 meter': return '200';
                        case '9,4 meter': return '300';
                    }
                case '3 lagen met plat dak':
                    switch(this.configdata.diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
                case '2 en 3 lagen met plat dak gecombineerd':
                    switch(this.configdata.diepte) {
                        case '8,8 meter': return '202';
                        case '9,4 meter': return '302';
                    }
            }
        },
        archprice: function() {
            return this.configdata.architectuurkosten;
        }
    },
    watch : {
      archprice: function() {
        if (this.archprice == 'Ter waarde van € 2500') {
          console.log("Updating!")
            // this.configdata.architectuur = 'Eigentijds';
            this.configdata.display.archj30 = 0;
        }
        else {this.configdata.display.archj30 = 1}
        if (this.configdata.architectuur == 'Jaren 30' && this.configdata.architectuurkosten =='Ter waarde van € 2500') {this.configdata.architectuur = 'Eigentijds'}
      },
      type: function() {
            var localdisplay = {
                beukmaat51: 1,
                beukmaat54: 1,
                beukmaat57: 1,
                beukmaat60: 0,
                archeigentijds: 1,
                archlandelijk: 1,
                archmodern: 1,
                archoudhollands: 1,
                diepte88: 1,
                diepte94: 1,
                diepte103: 0,
                aanbouw : 1,
                dakkapel: 0,
                tuitgevel: 0,
                slaapzolder: 0,
                wittedakplaten: 0,
                heefttweedeverdieping: 1,
                slaapkamerllb: 0,
            };
            if (this.configdata.architectuurkosten =='Ter waarde van € 2500') {localdisplay.archj30 = 0}
            else {localdisplay.archj30 = 1};
            if (this.configdata.diepte == '10,3 meter') {
                this.configdata.diepte = '8,8 meter';
            }
            switch(this.configdata.verschijningsvorm) {
                case '1 laag met kap (levensloopbestendig)':
                    localdisplay.beukmaat51 = 0;
                    localdisplay.beukmaat54 = 0;
                    localdisplay.beukmaat57 = 0;
                    localdisplay.beukmaat60 = 1;
                    localdisplay.archmodern = 0;
                    localdisplay.diepte88 = 0;
                    localdisplay.diepte94 = 0;
                    localdisplay.diepte103 = 1;
                    localdisplay.aanbouw = 0;
                    localdisplay.dakkapel = 1;
                    localdisplay.slaapkamerllb = 1;
                    this.configdata.diepte = '10,3 meter';
                    if (this.configdata.architectuur == 'Modern') {this.configdata.architectuur = 'Eigentijds'};
                    // this.configdata.aantallen.beukmaat60 = (this.configdata.aantallen.beukmaat60 < 2 ? 2 : this.configdata.aantallen.beukmaat60)
                    break;
                case '1 laag met kap':
                    localdisplay.diepte94 = 0;
                    localdisplay.archmodern = 0;
                    localdisplay.dakkapel = 1;
                    this.configdata.diepte = '8,8 meter';
                    if (this.configdata.architectuur == 'Modern') {this.configdata.architectuur = 'Eigentijds'};
                    break;
                case '2 lagen met kap':
                    localdisplay.tuitgevel = 1;
                    localdisplay.dakkapel = 1;
                    localdisplay.wittedakplaten = 1;
                    localdisplay.slaapzolder = 1;
                    break;
                case '2 en 3 lagen met plat dak gecombineerd':
                    localdisplay.slaapzolder = 1;
                    break;
                case '2 lagen met plat dak':
                    localdisplay.heefttweedeverdieping = 0;
                    break;
                case '3 lagen met plat dak':
                    localdisplay.slaapzolder = 1;
                    break;
            }
        this.configdata.display = localdisplay;
      }
    },
    updated: function() {
      this.$store.dispatch('updateConfiguration', {
        id: this.id,
        data: this.configdata
      }); //configurators[this.id] = this.configdata;
      // this.updateOverview({
      //   id: this.id,
      //   price: this.price,
      //   numberOfHouses: this.numberOfHouses,
      //   average: this.average,
      //   totalLength: this.totalLength,
      //   gbo: this.gbo,
      //   bi: this.bi,
      //   verschijningsvorm: this.configdata.verschijningsvorm,
      // })
      // fetch(
    }
}
</script>

<style>
input[type=text], select {
    width: 100%;
    padding: 4px 4px;
    margin: 3px 0;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 1px;
    box-sizing: border-box;
  }
  
  button[type=submit] {
    width: 100%;
    background-color: #4CAF50;
    color: white;
    padding: 14px 20px;
    margin: 8px 0;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button[type=submit]:hover {
    background-color: #45a049;
  }

input[type=number] {
  width: 40px;
  margin-right: 5px;
  float: right;
}

label {
  display: inline-block;
}

h1, h2, h3 {
    font-family: Bitter;
    margin: 5px;
}

p {
  margin: 5px;
  font-family: Arial;
}

body {
  background-color: #f9f8f8;
}
  
div.configurator {
  /* position: fixed; */
  border-radius: 0px;
  background-color: white;
  padding: 15px;
  max-width: 380px;
  margin: 20px;
  }

div.impression {
  /* margin-top: 20px; */
  margin-left: 440px; /* Same as the width of the sidenav */
  font-size: 16px; /* Increased text to enable scrolling */
  padding: 10px 10px;
  width: 1000px;
  /* background-color: #f2f2f2; */
  }

div.architecture, div.plattegronden {
  width: 930px;
  height: 300px;
  margin: 0 auto;
  padding: 10px;
  position: relative;
  float: center;
  display: block;
}

.impressie p {
  position: absolute;
  font-size: 70px;
  top: 40%;
  left: 2%;
  transform: rotate(-28deg);
  /* transform: translate(0, -50%); */
  text-align: center;
  color: white;
  opacity: 0.8; /* Firefox, Chrome, Safari, Opera, IE >= 9 (preview) */
  filter:alpha(opacity=50); /* for <= IE 8 */
}

.plattegronden p {
  position: absolute;
  font-size: 120px;
  top: 40%;
  left: 10%;
  transform: rotate(-22deg);
  /* transform: translate(0, -50%); */
  text-align: center;
  color: grey;
  opacity: 0.5; /* Firefox, Chrome, Safari, Opera, IE >= 9 (preview) */
  filter:alpha(opacity=50); /* for <= IE 8 */
}

div.impressie {
  width: 460px;
  float: left;
  padding-bottom: 20px;
  /* padding: 10px; */
}

img.architecture {
  /* display: block; */
  /* margin: auto; */
}

img.crop {
  width: 450px;
  height: 260px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Configurator.vue